import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dform_head"
}
const _hoisted_2 = { class: "dform_head_l" }
const _hoisted_3 = {
  key: 0,
  class: "dform_head"
}
const _hoisted_4 = {
  key: 1,
  class: "btn-wrap"
}
const _hoisted_5 = { class: "statewords" }
const _hoisted_6 = {
  key: 2,
  class: "dform_head"
}
const _hoisted_7 = { class: "btn-wrap" }
const _hoisted_8 = { class: "err-text" }
const _hoisted_9 = { class: "dialog-footer" }
const _hoisted_10 = { class: "dialog-footer" }
const _hoisted_11 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dformVue = _resolveComponent("dformVue")!
  const _component_dProcess = _resolveComponent("dProcess")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (_ctx.schema&&_ctx.schema.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "dform_head_title_befor" }, null, -1)),
              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "dform_head_title" }, "生源信息", -1)),
              _createElementVNode("div", {
                class: _normalizeClass(["dform_head_title_after", {turnRight:_ctx.hiddeTalentForm}]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hiddeTalentForm=!_ctx.hiddeTalentForm))
              }, null, 2)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showTalent)
        ? _withDirectives((_openBlock(), _createBlock(_component_dformVue, {
            key: 1,
            formconfig: _ctx.schema,
            data: _ctx.dataTalent,
            style: {"transition-duration":"0.5s"}
          }, null, 8, ["formconfig", "data"])), [
            [_vShow, !_ctx.hiddeTalentForm]
          ])
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      (_ctx.signForm&&_ctx.signForm.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[23] || (_cache[23] = [
            _createElementVNode("div", { class: "dform_head_l" }, [
              _createElementVNode("div", { class: "dform_head_title_befor" }),
              _createElementVNode("div", { class: "dform_head_title" }, "签约信息")
            ], -1)
          ])))
        : _createCommentVNode("", true),
      _createVNode(_component_dformVue, {
        class: "step2",
        formconfig: _ctx.signForm,
        data: _ctx.dataSign
      }, null, 8, ["formconfig", "data"]),
      (_ctx.isShowNOPass)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.isShowNOPass), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.requestStateData.request_state_list?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[24] || (_cache[24] = [
            _createElementVNode("div", { class: "dform_head_l" }, [
              _createElementVNode("div", { class: "dform_head_title_befor" }),
              _createElementVNode("div", { class: "dform_head_title" }, "流程信息")
            ], -1)
          ])))
        : _createCommentVNode("", true),
      (_ctx.requestStateData.request_state_list?.length)
        ? (_openBlock(), _createBlock(_component_dProcess, {
            key: 3,
            data: _ctx.requestStateData
          }, null, 8, ["data"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.permissionList.includes('CareerAffair_SignInCenter_Edit_Function'))
          ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _ctx.toEdit
            }, {
              default: _withCtx(() => _cache[25] || (_cache[25] = [
                _createTextVNode("修改")
              ])),
              _: 1,
              __: [25]
            }, 8, ["onClick"])), [
              [_vShow, _ctx.editBtn]
            ])
          : _createCommentVNode("", true),
        (_ctx.permissionList.includes('CareerAffair_SignInCenter_Audit_Function'))
          ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.approve()))
            }, {
              default: _withCtx(() => _cache[26] || (_cache[26] = [
                _createTextVNode("通过")
              ])),
              _: 1,
              __: [26]
            }, 512)), [
              [_vShow, _ctx.pass]
            ])
          : _createCommentVNode("", true),
        (_ctx.permissionList.includes('CareerAffair_SignInCenter_Audit_Function'))
          ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.disagreedialog = true))
            }, {
              default: _withCtx(() => _cache[27] || (_cache[27] = [
                _createTextVNode("未通过")
              ])),
              _: 1,
              __: [27]
            }, 512)), [
              [_vShow, _ctx.pass]
            ])
          : _createCommentVNode("", true),
        (_ctx.permissionList.includes('CareerAffair_SignInCenter_Audit_Function'))
          ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              key: 3,
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.rejectDialogShow = true))
            }, {
              default: _withCtx(() => _cache[28] || (_cache[28] = [
                _createTextVNode("驳回院系")
              ])),
              _: 1,
              __: [28]
            }, 512)), [
              [_vShow, _ctx.backFaculty]
            ])
          : _createCommentVNode("", true),
        (_ctx.permissionList.includes('CareerAffair_SignInCenter_Audit_Function'))
          ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              key: 4,
              type: "primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handBackDialogShow = true))
            }, {
              default: _withCtx(() => _cache[29] || (_cache[29] = [
                _createTextVNode("退回签约")
              ])),
              _: 1,
              __: [29]
            }, 512)), [
              [_vShow, _ctx.handBack]
            ])
          : _createCommentVNode("", true),
        (_ctx.permissionList.includes('CareerAffair_SignInCenter_Audit_Function'))
          ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              key: 5,
              type: "primary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.againcheck()))
            }, {
              default: _withCtx(() => _cache[30] || (_cache[30] = [
                _createTextVNode("重新审核")
              ])),
              _: 1,
              __: [30]
            }, 512)), [
              [_vShow, _ctx.isReset && _ctx.pattern != '1']
            ])
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validationrules()))
        }, {
          default: _withCtx(() => _cache[31] || (_cache[31] = [
            _createTextVNode("规则校验")
          ])),
          _: 1,
          __: [31]
        }, 512), [
          [_vShow, _ctx.pass]
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.errorshow,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.errorshow) = $event)),
      title: "规则校验",
      center: "",
      "custom-class": "custom_el_dialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkerror, (item) => {
            return (_openBlock(), _createElementBlock("div", { key: item }, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.error_msg), 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.disagreedialog,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.disagreedialog) = $event)),
      title: "请填写未通过原因",
      center: "",
      "custom-class": "custom_el_dialog"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_9, [
          _createVNode(_component_el_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.disagreedialog = false))
          }, {
            default: _withCtx(() => _cache[32] || (_cache[32] = [
              _createTextVNode("取消")
            ])),
            _: 1,
            __: [32]
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.disagree()))
          }, {
            default: _withCtx(() => _cache[33] || (_cache[33] = [
              _createTextVNode("确定")
            ])),
            _: 1,
            __: [33]
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { model: _ctx.checkinfo }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "未通过原因" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.checkinfo.reason,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.checkinfo.reason) = $event)),
                  autocomplete: "off",
                  maxlength: "100"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.handBackDialogShow,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.handBackDialogShow) = $event)),
      title: "退回签约",
      center: "",
      "custom-class": "custom_el_dialog"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_10, [
          _createVNode(_component_el_button, {
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handBackDialogShow = false))
          }, {
            default: _withCtx(() => _cache[34] || (_cache[34] = [
              _createTextVNode("取消")
            ])),
            _: 1,
            __: [34]
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handBackSign()))
          }, {
            default: _withCtx(() => _cache[35] || (_cache[35] = [
              _createTextVNode("确定")
            ])),
            _: 1,
            __: [35]
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { model: _ctx.handBackConfig }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "退回单位" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.handBackConfig.account_type,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.handBackConfig.account_type) = $event)),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "退回人才",
                      value: "talent"
                    }),
                    _createVNode(_component_el_option, {
                      label: "退回企业",
                      value: "department"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "退回原因" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.handBackConfig.reason,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.handBackConfig.reason) = $event)),
                  autocomplete: "off",
                  type: "textarea",
                  autosize: { minRows: 2, maxRows: 4 },
                  resize: "none",
                  maxlength: "100"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.rejectDialogShow,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.rejectDialogShow) = $event)),
      title: "驳回院系",
      center: "",
      "custom-class": "custom_el_dialog"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_el_button, {
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.rejectDialogShow = false))
          }, {
            default: _withCtx(() => _cache[36] || (_cache[36] = [
              _createTextVNode("取消")
            ])),
            _: 1,
            __: [36]
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.rejectSign()))
          }, {
            default: _withCtx(() => _cache[37] || (_cache[37] = [
              _createTextVNode("确定")
            ])),
            _: 1,
            __: [37]
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { model: _ctx.rejectConfig }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "驳回原因" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.rejectConfig.value,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.rejectConfig.value) = $event)),
                  autocomplete: "off",
                  type: "textarea",
                  autosize: { minRows: 2, maxRows: 4 },
                  resize: "none"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}